export const ACCOUNT_TYPE_UNSPECIFIED = 'ACCOUNT_TYPE_UNSPECIFIED';
export const ACCOUNT_TYPE_UNSPECIFIED_LABEL = 'Unspecified';

export const ACCOUNT_TYPE_LABELS = {
  PERSONAL: 'Personal Account',
  LOCATION_GROUP: 'Location Group',
  USER_GROUP: 'User Group',
  ORGANIZATION: 'Organization',
  ACCOUNT_TYPE_UNSPECIFIED: 'Unspecified',
};

export const ACCOUNT_TYPE_ICONS = {
  PERSONAL: 'user',
  LOCATION_GROUP: 'map marker alternate',
  USER_GROUP: 'users',
  ORGANIZATION: 'building',
  ACCOUNT_TYPE_UNSPECIFIED: 'question circle outline',
};
